module.exports = __webpack_public_path__ + "static/media/20.1a7f5380.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/20.jpg
// module id = 710
// module chunks = 0